export const dataMain = {
  imgSrc: [
    require("./assets/images/main/mptXopowoBackground.jpg"),  // 0
    require("./assets/images/main/mptXopowoHomeUp.png"),  // 1
    require("./assets/images/main/mptXopowoHomeDown.png"),  // 2
    require("./assets/images/main/mptXopowoOpenseaUp.png"),  // 3
    require("./assets/images/main/mptXopowoOpenseaDown.png"),  // 4
    require("./assets/images/main/mptXopowoGenesisNFT.jpg"),  // 5
    require("./assets/images/main/mptXopowoOnyxNFT.jpg"),  // 6
    require("./assets/images/main/mptXopowoGlacierNFT.jpg"),  // 7
    require("./assets/images/main/mptXopowoNightmareNFT.jpg"),  // 8
    require("./assets/images/main/mptXopowoSunsetNFT.jpg"),  // 9
    require("./assets/images/main/mptXopowoTempleNFT.jpg"),  // 10
    require("./assets/images/main/xopowoSoundIdentifierPanel.png"),  // 11
    require("./assets/images/main/mptXopowoAcidNFT.jpg"),  // 12
    require("./assets/images/main/mptXopowoPoisonedNFT.jpg"),  // 13
    require("./assets/images/main/mptXopowoRoyaleNFT.jpg"),  // 14
    require("./assets/images/main/mptXopowoVolcanoNFT.jpg"),  // 15
    require("./assets/images/main/mptSekansPrototypeNFT.jpg"),  // 16
    require("./assets/images/main/sekansSoundIdentifierPanel.png"),  // 17
    require("./assets/images/main/fullscreenDown.png"),  // 18
    require("./assets/images/main/fullscreenUp.png"),  // 19
  ]
}

export const dataMptsSelectorsXowopo = [
  {
    version: "GENESIS",
    model: "Edition",
    imgSrc: require("./assets/images/main/mptXopowoGenesisNFT.jpg"),
    path: "/x0p0w0genesis",
    acceskey: "0",
  },
  {
    version: "ONYX",
    model: "Edition",
    imgSrc: require("./assets/images/main/mptXopowoOnyxNFT.jpg"),
    path: "/x0p0w0onyx",
    acceskey: "1",
  },
  {
    version: "TEMPLE",
    model: "Edition",
    imgSrc: require("./assets/images/main/mptXopowoTempleNFT.jpg"),
    path: "/x0p0w0temple",
    acceskey: "2",
  },
  {
    version: "NIGHTMARE",
    model: "Edition",
    imgSrc: require("./assets/images/main/mptXopowoNightmareNFT.jpg"),
    path: "/x0p0w0nightmare",
    acceskey: "3",
  },
  {
    version: "VOLCANO",
    model: "Edition",
    imgSrc: require("./assets/images/main/mptXopowoVolcanoNFT.jpg"),
    path: "/x0p0w0volcano",
    acceskey: "4",
  },
  {
    version: "GLACIER",
    model: "Edition",
    imgSrc: require("./assets/images/main/mptXopowoGlacierNFT.jpg"),
    path: "/x0p0w0glacier",
    acceskey: "5",
  },
  {
    version: "ROYALE",
    model: "Edition",
    imgSrc: require("./assets/images/main/mptXopowoRoyaleNFT.jpg"),
    path: "/x0p0w0royale",
    acceskey: "6",
  },
  {
    version: "ACID",
    model: "Edition",
    imgSrc: require("./assets/images/main/mptXopowoAcidNFT.jpg"),
    path: "/x0p0w0acid",
    acceskey: "7",
  },
  {
    version: "POISONED",
    model: "Edition",
    imgSrc: require("./assets/images/main/mptXopowoPoisonedNFT.jpg"),
    path: "/x0p0w0poisoned",
    acceskey: "8",
  },
  {
    version: "SUNSET",
    model: "Edition",
    imgSrc: require("./assets/images/main/mptXopowoSunsetNFT.jpg"),
    path: "/x0p0w0sunset",
    acceskey: "9",
  },
]

export const dataMptsSelectorsSekans = [
  {
    version: "Prototype",
    model: "Edition",
    imgSrc: require("./assets/images/main/mptSekansPrototypeNFT.jpg"),
    path: "/sekansprototype",
    acceskey: "shift + 0",
  },
  {
    version: "Glacier",
    model: "Edition",
    imgSrc: require("./assets/images/main/mptSekansGlacierNFT.jpg"),
    path: "/sekansglacier",
    acceskey: "shift + 1",
  },
  {
    version: "Acid",
    model: "Edition",
    imgSrc: require("./assets/images/main/mptSekansAcidNFT.jpg"),
    path: "/sekansacid",
    acceskey: "shift + 2",
  },
  {
    version: "Volcano",
    model: "Edition",
    imgSrc: require("./assets/images/main/mptSekansVolcanoNFT.jpg"),
    path: "/sekansvolcano",
    acceskey: "shift + 3",
  },
  {
    version: "Royale",
    model: "Edition",
    imgSrc: require("./assets/images/main/mptSekansRoyaleNFT.jpg"),
    path: "/sekansroyale",
    acceskey: "shift + 4",
  },
]

export const dataMptsSelectorsPrototype = [
  {
    version: "SEQUENCEUR",
    model: "Edition",
    imgSrc: require("./assets/images/main/mptSequenceur.jpg"),
    path: "/sequenceur",
    acceskey: "p",
  },
  {
    version: "RECORDER",
    model: "Edition",
    imgSrc: require("./assets/images/main/mptRecorder.jpg"),
    path: "/recorder",
    acceskey: "i",
  },
  {
    version: "PIANO",
    model: "Edition",
    imgSrc: require("./assets/images/main/mptPiano.png"),
    path: "/piano",
    acceskey: "l",
  },
  {
    version: "MIXER",
    model: "Edition",
    imgSrc: require("./assets/images/main/mptMixer.png"),
    path: "/mixer",
    acceskey: "l",
  },
  {
    version: "MPTPageContent",
    model: "Edition",
    imgSrc: require("./assets/images/main/mptMixer.png"),
    path: "/mptpagecontent",
    acceskey: "l",
  },
  {
    version: "Arpeggio",
    model: "Edition",
    imgSrc: require("./assets/images/main/mptArpeggioPrototypeNFT.png"),
    path: "/arpeggioprototype",
    acceskey: "l",
  },

]

export const dataGenesis = {
  model: 'xopowo',
  edition: 'genesis',
  accessKeyPanel: {
    imgSrc: require("./assets/images/xopowoGenesis/mptXopowoGenesisPanel.png"),
    alt: "accessKeyPanel",
  },
  imagesSrc: [
    require("./assets/images/xopowoGenesis/loopOff.png"),
    require("./assets/images/xopowoGenesis/loopOn.png"),
    require("./assets/images/xopowoGenesis/mptXopowoGenesis.jpg"),
    require("./assets/images/xopowoGenesis/ownershipOff.png"),
    require("./assets/images/xopowoGenesis/ownershipOn.png"),
    require("./assets/images/xopowoGenesis/resetOff.png"),
    require("./assets/images/xopowoGenesis/resetOn.png"),
    require("./assets/images/xopowoGenesis/screenBass1.png"),
    require("./assets/images/xopowoGenesis/screenBass2.png"),
    require("./assets/images/xopowoGenesis/screenBass3.png"),
    require("./assets/images/xopowoGenesis/screenHihats.png"),
    require("./assets/images/xopowoGenesis/screenKick.png"),
    require("./assets/images/xopowoGenesis/screenSnare.png"),
    require("./assets/images/xopowoGenesis/screenPad1.png"),
    require("./assets/images/xopowoGenesis/screenPad2.png"),
    require("./assets/images/xopowoGenesis/screenPad3.png"),
    require("./assets/images/xopowoGenesis/screenLoop.png"),
    require("./assets/images/xopowoGenesis/padUp.png"),
    require("./assets/images/xopowoGenesis/padDown.png"),
    require("./assets/images/xopowoGenesis/mptXopowoGenesisPanel.png"),
    require("./assets/images/xopowoGenesis/beatOff.png"),
    require("./assets/images/xopowoGenesis/beatOn.png"),
    require("./assets/images/xopowoGenesis/screenBeat.png"),
  ],
  nftPath: "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/57703132890668813036986655783405950636450175475927794675628972147925302902785",
  contractAdress: "0x495f947276749Ce646f68AC8c248420045cb7b5e",
  tokenId: "57703132890668813036986655783405950636450175475927794675628972147925302902785",
  audios: [
    "bass1XG",
    "bass2XG",
    "bass3XG",
    "hihatXG",
    "kickXG",
    "snareXG",
    "pad1XG",
    "pad2XG",
    "pad3XG",
    "loopXG",
    "beatXG",
  ],
  accessKey: 0,
}

export const dataOnyx = {
  model: 'xopowo',
  edition: 'onyx',
  accessKeyPanel: {
    imgSrc: require("./assets/images/xopowoOnyx/mptXopowoOnyxPanel.png"),
    alt: "accessKeyPanel",
  },
  imagesSrc: [
    require("./assets/images/xopowoOnyx/loopOff.png"),
    require("./assets/images/xopowoOnyx/loopOn.png"),
    require("./assets/images/xopowoOnyx/mptXopowoOnyx.jpg"),
    require("./assets/images/xopowoOnyx/ownershipOff.png"),
    require("./assets/images/xopowoOnyx/ownershipOn.png"),
    require("./assets/images/xopowoOnyx/resetOff.png"),
    require("./assets/images/xopowoOnyx/resetOn.png"),
    require("./assets/images/xopowoOnyx/screenBass1.png"),
    require("./assets/images/xopowoOnyx/screenBass2.png"),
    require("./assets/images/xopowoOnyx/screenBass3.png"),
    require("./assets/images/xopowoOnyx/screenHihats.png"),
    require("./assets/images/xopowoOnyx/screenKick.png"),
    require("./assets/images/xopowoOnyx/screenSnare.png"),
    require("./assets/images/xopowoOnyx/screenPad1.png"),
    require("./assets/images/xopowoOnyx/screenPad2.png"),
    require("./assets/images/xopowoOnyx/screenPad3.png"),
    require("./assets/images/xopowoOnyx/screenLoop.png"),
    require("./assets/images/xopowoOnyx/padUp.png"),
    require("./assets/images/xopowoOnyx/padDown.png"),
    require("./assets/images/xopowoOnyx/mptXopowoOnyxPanel.png"),
    require("./assets/images/xopowoOnyx/beatOff.png"),
    require("./assets/images/xopowoOnyx/beatOn.png"),
    require("./assets/images/xopowoOnyx/screenBeat.png"),
  ],
  nftPath: "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/57703132890668813036986655783405950636450175475927794675628972149024814530561",
  contractAdress: "0x495f947276749Ce646f68AC8c248420045cb7b5e",
  tokenId: "57703132890668813036986655783405950636450175475927794675628972149024814530561",
  audios: [
    "bass1XO",
    "bass2XO",
    "bass3XO",
    "hihatXO",
    "kickXO",
    "snareXO",
    "pad1XO",
    "pad2XO",
    "pad3XO",
    "loopXO",
    "beatXO",
  ],
  accessKey: 1,
}

export const dataGlacier = {
  model: 'xopowo',
  edition: 'glacier',
  accessKeyPanel: {
    imgSrc: require("./assets/images/xopowoGlacier/mptXopowoGlacierPanel.png"),
    alt: "accessKeyPanel",
  },
  imagesSrc: [
    require("./assets/images/xopowoGlacier/loopOff.png"),
    require("./assets/images/xopowoGlacier/loopOn.png"),
    require("./assets/images/xopowoGlacier/mptXopowoGlacier.jpg"),
    require("./assets/images/xopowoGlacier/ownershipOff.png"),
    require("./assets/images/xopowoGlacier/ownershipOn.png"),
    require("./assets/images/xopowoGlacier/resetOff.png"),
    require("./assets/images/xopowoGlacier/resetOn.png"),
    require("./assets/images/xopowoGlacier/screenBass1.png"),
    require("./assets/images/xopowoGlacier/screenBass2.png"),
    require("./assets/images/xopowoGlacier/screenBass3.png"),
    require("./assets/images/xopowoGlacier/screenHihats.png"),
    require("./assets/images/xopowoGlacier/screenKick.png"),
    require("./assets/images/xopowoGlacier/screenSnare.png"),
    require("./assets/images/xopowoGlacier/screenPad1.png"),
    require("./assets/images/xopowoGlacier/screenPad2.png"),
    require("./assets/images/xopowoGlacier/screenPad3.png"),
    require("./assets/images/xopowoGlacier/screenLoop.png"),
    require("./assets/images/xopowoGlacier/padUp.png"),
    require("./assets/images/xopowoGlacier/padDown.png"),
    require("./assets/images/xopowoGlacier/mptXopowoGlacierPanel.png"),
    require("./assets/images/xopowoGlacier/beatOff.png"),
    require("./assets/images/xopowoGlacier/beatOn.png"),
    require("./assets/images/xopowoGlacier/screenBeat.png"),
  ],
  nftPath: "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/57703132890668813036986655783405950636450175475927794675628972150124326158337",
  contractAdress: "0x495f947276749Ce646f68AC8c248420045cb7b5e",
  tokenId: "57703132890668813036986655783405950636450175475927794675628972150124326158337",
  audios: [
    "bass1XGl",
    "bass2XGl",
    "bass3XGl",
    "hihatXGl",
    "kickXGl",
    "snareXGl",
    "pad1XGl",
    "pad2XGl",
    "pad3XGl",
    "loopXGl",
    "beatXGl",
  ],
  accessKey: 5,
}

export const dataNightmare = {
  model: 'xopowo',
  edition: 'nigthmare',
  accessKeyPanel: {
    imgSrc: require("./assets/images/xopowoNightmare/mptXopowoNightmarePanel.png"),
    alt: "accessKeyPanel",
  },
  imagesSrc: [
    require("./assets/images/xopowoNightmare/loopOff.png"),
    require("./assets/images/xopowoNightmare/loopOn.png"),
    require("./assets/images/xopowoNightmare/mptXopowoNightmare.jpg"),
    require("./assets/images/xopowoNightmare/ownershipOff.png"),
    require("./assets/images/xopowoNightmare/ownershipOn.png"),
    require("./assets/images/xopowoNightmare/resetOff.png"),
    require("./assets/images/xopowoNightmare/resetOn.png"),
    require("./assets/images/xopowoNightmare/screenBass1.png"),
    require("./assets/images/xopowoNightmare/screenBass2.png"),
    require("./assets/images/xopowoNightmare/screenBass3.png"),
    require("./assets/images/xopowoNightmare/screenHihats.png"),
    require("./assets/images/xopowoNightmare/screenKick.png"),
    require("./assets/images/xopowoNightmare/screenSnare.png"),
    require("./assets/images/xopowoNightmare/screenPad1.png"),
    require("./assets/images/xopowoNightmare/screenPad2.png"),
    require("./assets/images/xopowoNightmare/screenPad3.png"),
    require("./assets/images/xopowoNightmare/screenLoop.png"),
    require("./assets/images/xopowoNightmare/padUp.png"),
    require("./assets/images/xopowoNightmare/padDown.png"),
    require("./assets/images/xopowoNightmare/mptXopowoNightmarePanel.png"),
    require("./assets/images/xopowoNightmare/beatOff.png"),
    require("./assets/images/xopowoNightmare/beatOn.png"),
    require("./assets/images/xopowoNightmare/screenBeat.png"),
  ],
  nftPath: "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/57703132890668813036986655783405950636450175475927794675628972151223837786113",
  contractAdress: "0x495f947276749Ce646f68AC8c248420045cb7b5e",
  tokenId: "57703132890668813036986655783405950636450175475927794675628972151223837786113",
  audios: [
    "bass1XN",
    "bass2XN",
    "bass3XN",
    "hihatXN",
    "kickXN",
    "snareXN",
    "pad1XN",
    "pad2XN",
    "pad3XN",
    "loopXN",
    "beatXN",
  ],
  accessKey: 3,
}

export const dataSunset = {
  model: 'xopowo',
  edition: 'sunset',
  accessKeyPanel: {
    imgSrc: require("./assets/images/xopowoSunset/mptXopowoSunsetPanel.png"),
    alt: "accessKeyPanel",
  },
  imagesSrc: [
    require("./assets/images/xopowoSunset/loopOFF.png"),
    require("./assets/images/xopowoSunset/loopON.png"),
    require("./assets/images/xopowoSunset/mptXopowoSunset.jpg"),
    require("./assets/images/xopowoSunset/ownershipOff.png"),
    require("./assets/images/xopowoSunset/ownershipOn.png"),
    require("./assets/images/xopowoSunset/resetOff.png"),
    require("./assets/images/xopowoSunset/resetOn.png"),
    require("./assets/images/xopowoSunset/screenBass1.png"),
    require("./assets/images/xopowoSunset/screenBass2.png"),
    require("./assets/images/xopowoSunset/screenBass3.png"),
    require("./assets/images/xopowoSunset/screenHihats.png"),
    require("./assets/images/xopowoSunset/screenKick.png"),
    require("./assets/images/xopowoSunset/screenSnare.png"),
    require("./assets/images/xopowoSunset/screenPad1.png"),
    require("./assets/images/xopowoSunset/screenPad2.png"),
    require("./assets/images/xopowoSunset/screenPad3.png"),
    require("./assets/images/xopowoSunset/screenLoop.png"),
    require("./assets/images/xopowoSunset/padUp.png"),
    require("./assets/images/xopowoSunset/padDown.png"),
    require("./assets/images/xopowoSunset/mptXopowoSunsetPanel.png"),
    require("./assets/images/xopowoSunset/beatOff.png"),
    require("./assets/images/xopowoSunset/beatOn.png"),
    require("./assets/images/xopowoSunset/screenBeat.png"),
  ],
  nftPath: "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/57703132890668813036986655783405950636450175475927794675628972152323349413889",
  contractAdress: "0x495f947276749Ce646f68AC8c248420045cb7b5e",
  tokenId: "57703132890668813036986655783405950636450175475927794675628972152323349413889",
  audios: [
    "bass1XS",
    "bass2XS",
    "bass3XS",
    "hihatXS",
    "kickXS",
    "snareXS",
    "pad1XS",
    "pad2XS",
    "pad3XS",
    "loopXS",
    "beatXS",
  ],
  accessKey: 9,
}

export const dataTemple = {
  model: 'xopowo',
  edition: 'temple',
  accessKeyPanel: {
    imgSrc: require("./assets/images/xopowoTemple/mptXopowoTemplePanel.png"),
    alt: "accessKeyPanel",
  },
  imagesSrc: [
    require("./assets/images/xopowoTemple/loopOFF.png"),
    require("./assets/images/xopowoTemple/loopON.png"),
    require("./assets/images/xopowoTemple/mptXopowoTemple.jpg"),
    require("./assets/images/xopowoTemple/ownershipOff.png"),
    require("./assets/images/xopowoTemple/ownershipOn.png"),
    require("./assets/images/xopowoTemple/resetOff.png"),
    require("./assets/images/xopowoTemple/resetOn.png"),
    require("./assets/images/xopowoTemple/screenBass1.png"),
    require("./assets/images/xopowoTemple/screenBass2.png"),
    require("./assets/images/xopowoTemple/screenBass3.png"),
    require("./assets/images/xopowoTemple/screenHihats.png"),
    require("./assets/images/xopowoTemple/screenKick.png"),
    require("./assets/images/xopowoTemple/screenSnare.png"),
    require("./assets/images/xopowoTemple/screenPad1.png"),
    require("./assets/images/xopowoTemple/screenPad2.png"),
    require("./assets/images/xopowoTemple/screenPad3.png"),
    require("./assets/images/xopowoTemple/screenLoop.png"),
    require("./assets/images/xopowoTemple/padUp.png"),
    require("./assets/images/xopowoTemple/padDown.png"),
    require("./assets/images/xopowoTemple/mptXopowoTemplePanel.png"),
    require("./assets/images/xopowoTemple/beatOff.png"),
    require("./assets/images/xopowoTemple/beatOn.png"),
    require("./assets/images/xopowoTemple/screenBeat.png"),
  ],
  nftPath: "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/57703132890668813036986655783405950636450175475927794675628972153422861041665",
  contractAdress: "0x495f947276749Ce646f68AC8c248420045cb7b5e",
  tokenId: "57703132890668813036986655783405950636450175475927794675628972153422861041665",
  audios: [
    "bass1XT",
    "bass2XT",
    "bass3XT",
    "hihatXT",
    "kickXT",
    "snareXT",
    "pad1XT",
    "pad2XT",
    "pad3XT",
    "loopXT",
    "beatXT",
  ],
  accessKey: 2,
}

export const dataAcid = {
  model: 'xopowo',
  edition: 'acid',
  accessKeyPanel: {
    imgSrc: require("./assets/images/xopowoAcid/mptXopowoAcidPanel.png"),
    alt: "accessKeyPanel",
  },
  imagesSrc: [
    require("./assets/images/xopowoAcid/beatOff.png"),
    require("./assets/images/xopowoAcid/beatOn.png"),
    require("./assets/images/xopowoAcid/mptXopowoAcid.jpg"),
    require("./assets/images/xopowoAcid/ownershipOff.png"),
    require("./assets/images/xopowoAcid/ownershipOn.png"),
    require("./assets/images/xopowoAcid/resetOff.png"),
    require("./assets/images/xopowoAcid/resetOn.png"),
    require("./assets/images/xopowoAcid/screenBass1.png"),
    require("./assets/images/xopowoAcid/screenBass2.png"),
    require("./assets/images/xopowoAcid/screenBass3.png"),
    require("./assets/images/xopowoAcid/screenHihats.png"),
    require("./assets/images/xopowoAcid/screenKick.png"),
    require("./assets/images/xopowoAcid/screenSnare.png"),
    require("./assets/images/xopowoAcid/screenPad1.png"),
    require("./assets/images/xopowoAcid/screenPad2.png"),
    require("./assets/images/xopowoAcid/screenPad3.png"),
    require("./assets/images/xopowoAcid/screenLoop.png"),
    require("./assets/images/xopowoAcid/padUp.png"),
    require("./assets/images/xopowoAcid/padDown.png"),
    require("./assets/images/xopowoAcid/mptXopowoAcidPanel.png"),
    require("./assets/images/xopowoAcid/loopOff.png"),
    require("./assets/images/xopowoAcid/loopOn.png"),
    require("./assets/images/xopowoAcid/screenBeat.png"),
  ],
  nftPath: "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/57703132890668813036986655783405950636450175475927794675628972154522372669441",
  contractAdress: "0x495f947276749Ce646f68AC8c248420045cb7b5e",
  tokenId: "57703132890668813036986655783405950636450175475927794675628972154522372669441",
  audios: [
    "bass1XA",
    "bass2XA",
    "bass3XA",
    "hihatXA",
    "kickXA",
    "snareXA",
    "pad1XA",
    "pad2XA",
    "pad3XA",
    "loopXA",
    "beatXA",
  ],
  accessKey: 7,
}

export const dataPoisoned = {
  model: 'xopowo',
  edition: 'poisoned',
  accessKeyPanel: {
    imgSrc: require("./assets/images/xopowoPoisoned/mptXopowoPoisonedPanel.png"),
    alt: "accessKeyPanel",
  },
  imagesSrc: [
    require("./assets/images/xopowoPoisoned/beatOff.png"),
    require("./assets/images/xopowoPoisoned/beatOn.png"),
    require("./assets/images/xopowoPoisoned/mptXopowoPoisoned.jpg"),
    require("./assets/images/xopowoPoisoned/ownershipOff.png"),
    require("./assets/images/xopowoPoisoned/ownershipOn.png"),
    require("./assets/images/xopowoPoisoned/resetOff.png"),
    require("./assets/images/xopowoPoisoned/resetOn.png"),
    require("./assets/images/xopowoPoisoned/screenBass1.png"),
    require("./assets/images/xopowoPoisoned/screenBass2.png"),
    require("./assets/images/xopowoPoisoned/screenBass3.png"),
    require("./assets/images/xopowoPoisoned/screenHihats.png"),
    require("./assets/images/xopowoPoisoned/screenKick.png"),
    require("./assets/images/xopowoPoisoned/screenSnare.png"),
    require("./assets/images/xopowoPoisoned/screenPad1.png"),
    require("./assets/images/xopowoPoisoned/screenPad2.png"),
    require("./assets/images/xopowoPoisoned/screenPad3.png"),
    require("./assets/images/xopowoPoisoned/screenLoop.png"),
    require("./assets/images/xopowoPoisoned/padUp.png"),
    require("./assets/images/xopowoPoisoned/padDown.png"),
    require("./assets/images/xopowoPoisoned/mptXopowoPoisonedPanel.png"),
    require("./assets/images/xopowoPoisoned/loopOff.png"),
    require("./assets/images/xopowoPoisoned/loopOn.png"),
    require("./assets/images/xopowoPoisoned/screenBeat.png"),
  ],
  nftPath: "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/57703132890668813036986655783405950636450175475927794675628972155621884297217",
  contractAdress: "0x495f947276749Ce646f68AC8c248420045cb7b5e",
  tokenId: "57703132890668813036986655783405950636450175475927794675628972155621884297217",
  audios: [
    "bass1XP",
    "bass2XP",
    "bass3XP",
    "hihatXP",
    "kickXP",
    "snareXP",
    "pad1XP",
    "pad2XP",
    "pad3XP",
    "loopXP",
    "beatXP",
  ],
  accessKey: 8,
}

export const dataRoyale = {
  model: 'xopowo',
  edition: 'royale',
  accessKeyPanel: {
    imgSrc: require("./assets/images/xopowoRoyale/mptXopowoRoyalePanel.png"),
    alt: "accessKeyPanel",
  },
  imagesSrc: [
    require("./assets/images/xopowoRoyale/beatOff.png"),
    require("./assets/images/xopowoRoyale/beatOn.png"),
    require("./assets/images/xopowoRoyale/mptXopowoRoyale.jpg"),
    require("./assets/images/xopowoRoyale/ownershipOff.png"),
    require("./assets/images/xopowoRoyale/ownershipOn.png"),
    require("./assets/images/xopowoRoyale/resetOff.png"),
    require("./assets/images/xopowoRoyale/resetOn.png"),
    require("./assets/images/xopowoRoyale/screenBass1.png"),
    require("./assets/images/xopowoRoyale/screenBass2.png"),
    require("./assets/images/xopowoRoyale/screenBass3.png"),
    require("./assets/images/xopowoRoyale/screenHihats.png"),
    require("./assets/images/xopowoRoyale/screenKick.png"),
    require("./assets/images/xopowoRoyale/screenSnare.png"),
    require("./assets/images/xopowoRoyale/screenPad1.png"),
    require("./assets/images/xopowoRoyale/screenPad2.png"),
    require("./assets/images/xopowoRoyale/screenPad3.png"),
    require("./assets/images/xopowoRoyale/screenLoop.png"),
    require("./assets/images/xopowoRoyale/padUp.png"),
    require("./assets/images/xopowoRoyale/padDown.png"),
    require("./assets/images/xopowoRoyale/mptXopowoRoyalePanel.png"),
    require("./assets/images/xopowoRoyale/loopOff.png"),
    require("./assets/images/xopowoRoyale/loopOn.png"),
    require("./assets/images/xopowoRoyale/screenBeat.png"),
  ],
  nftPath: "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/57703132890668813036986655783405950636450175475927794675628972156721395924993",
  contractAdress: "0x495f947276749Ce646f68AC8c248420045cb7b5e",
  tokenId: "57703132890668813036986655783405950636450175475927794675628972156721395924993",
  audios: [
    "bass1XR",
    "bass2XR",
    "bass3XR",
    "hihatXR",
    "kickXR",
    "snareXR",
    "pad1XR",
    "pad2XR",
    "pad3XR",
    "loopXR",
    "beatXR",
  ],
  accessKey: 6,
}

export const dataVolcano = {
  model: 'xopowo',
  edition: 'volcano',
  accessKeyPanel: {
    imgSrc: require("./assets/images/xopowoVolcano/mptXopowoVolcanoPanel.png"),
    alt: "accessKeyPanel",
  },
  imagesSrc: [
    require("./assets/images/xopowoVolcano/beatOff.png"),
    require("./assets/images/xopowoVolcano/beatOn.png"),
    require("./assets/images/xopowoVolcano/mptXopowoVolcano.jpg"),
    require("./assets/images/xopowoVolcano/ownershipOff.png"),
    require("./assets/images/xopowoVolcano/ownershipOn.png"),
    require("./assets/images/xopowoVolcano/resetOff.png"),
    require("./assets/images/xopowoVolcano/resetOn.png"),
    require("./assets/images/xopowoVolcano/screenBass1.png"),
    require("./assets/images/xopowoVolcano/screenBass2.png"),
    require("./assets/images/xopowoVolcano/screenBass3.png"),
    require("./assets/images/xopowoVolcano/screenHihats.png"),
    require("./assets/images/xopowoVolcano/screenKick.png"),
    require("./assets/images/xopowoVolcano/screenSnare.png"),
    require("./assets/images/xopowoVolcano/screenPad1.png"),
    require("./assets/images/xopowoVolcano/screenPad2.png"),
    require("./assets/images/xopowoVolcano/screenPad3.png"),
    require("./assets/images/xopowoVolcano/screenLoop.png"),
    require("./assets/images/xopowoVolcano/padUp.png"),
    require("./assets/images/xopowoVolcano/padDown.png"),
    require("./assets/images/xopowoVolcano/mptXopowoVolcanoPanel.png"),
    require("./assets/images/xopowoVolcano/loopOff.png"),
    require("./assets/images/xopowoVolcano/loopOn.png"),
    require("./assets/images/xopowoVolcano/screenBeat.png"),
  ],
  nftPath: "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/57703132890668813036986655783405950636450175475927794675628972157820907552769",
  contractAdress: "0x495f947276749Ce646f68AC8c248420045cb7b5e",
  tokenId: "57703132890668813036986655783405950636450175475927794675628972157820907552769",
  audios: [
    "bass1XV",
    "bass2XV",
    "bass3XV",
    "hihatXV",
    "kickXV",
    "snareXV",
    "pad1XV",
    "pad2XV",
    "pad3XV",
    "loopXV",
    "beatXV",
  ],
  accessKey: 4,
}

export const dataSekansPrototype = {
  model: 'sekans',
  edition: 'prototype',
  accessKeyPanel: {
    imgSrc: require("./assets/images/sekansPrototype/sekansPrototypeAccessKeyPanel.png"),
    alt: "accessKeyPanel",
  },
  imagesSrc: [
    require("./assets/images/sekansPrototype/mptSekansPrototypeFrame.jpg"),
    require("./assets/images/sekansPrototype/kick.png"),
    require("./assets/images/sekansPrototype/snare.png"),
    require("./assets/images/sekansPrototype/closed.png"),
    require("./assets/images/sekansPrototype/open.png"),
    require("./assets/images/sekansPrototype/clap.png"),
    require("./assets/images/sekansPrototype/cowbell.png"),
    require("./assets/images/sekansPrototype/cursorPadUnactive.png"),
    require("./assets/images/sekansPrototype/cursorPadActive.png"),

    require("./assets/images/sekansPrototype/bonusSoundPad1Up.png"),
    require("./assets/images/sekansPrototype/bonusSoundPad1Down.png"),
    require("./assets/images/sekansPrototype/bonusSoundPad2Up.png"),
    require("./assets/images/sekansPrototype/bonusSoundPad2Down.png"),
    require("./assets/images/sekansPrototype/bonusSoundPad3Up.png"),
    require("./assets/images/sekansPrototype/bonusSoundPad3Down.png"),
    require("./assets/images/sekansPrototype/bonusSoundsStopUp.png"),
    require("./assets/images/sekansPrototype/bonusSoundsStopDown.png"),
    require("./assets/images/sekansPrototype/stepLightOff.png"),
    require("./assets/images/sekansPrototype/stepLightOn.png"),

    require("./assets/images/sekansPrototype/bpmDisplay1.png"),
    require("./assets/images/sekansPrototype/bpmDisplay2.png"),
    require("./assets/images/sekansPrototype/bpmDisplay3.png"),
    require("./assets/images/sekansPrototype/bpmDisplay4.png"),
    require("./assets/images/sekansPrototype/bpmDisplay5.png"),
    require("./assets/images/sekansPrototype/bpmMinusUp.png"),
    require("./assets/images/sekansPrototype/bpmMinusDown.png"),
    require("./assets/images/sekansPrototype/bpmPlusUp.png"),
    require("./assets/images/sekansPrototype/bpmPlusDown.png"),
    require("./assets/images/sekansPrototype/playStopUp.png"),
    require("./assets/images/sekansPrototype/playStopDown.png"),
    require("./assets/images/sekansPrototype/arrowUpUp.png"),
    require("./assets/images/sekansPrototype/arrowUpDown.png"),
    require("./assets/images/sekansPrototype/nftLinkUp.png"),
    require("./assets/images/sekansPrototype/nftLinkDown.png"),

    require("./assets/images/sekansPrototype/resetUp.png"),
    require("./assets/images/sekansPrototype/resetDown.png"),
    require("./assets/images/sekansPrototype/clearPadsUp.png"),
    require("./assets/images/sekansPrototype/clearPadsDown.png"),
    require("./assets/images/sekansPrototype/clearLineUp.png"),
    require("./assets/images/sekansPrototype/clearLineDown.png"),
    require("./assets/images/sekansPrototype/mutePadsUp.png"),
    require("./assets/images/sekansPrototype/mutePadsDown.png"),
    require("./assets/images/sekansPrototype/activateCursorUp.png"),
    require("./assets/images/sekansPrototype/activateCursorDown.png"),
    require("./assets/images/sekansPrototype/arrowLeftUp.png"),
    require("./assets/images/sekansPrototype/arrowLeftDown.png"),
    require("./assets/images/sekansPrototype/arrowDownUp.png"),
    require("./assets/images/sekansPrototype/arrowDownDown.png"),
    require("./assets/images/sekansPrototype/arrowRightUp.png"),
    require("./assets/images/sekansPrototype/arrowRightDown.png"),
  ],
  nftPath: "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/57703132890668813036986655783405950636450175475927794675628972158920419180545",
  contractAdress: "0x495f947276749ce646f68ac8c248420045cb7b5e",
  tokenId: "57703132890668813036986655783405950636450175475927794675628972158920419180545",
  audios: [
    "kickSP",
    "snareSP",
    "hihatSP",
    "openHihatSP",
    "clapSP",
    "cowbellSP",
    "bonus1SP",
    "bonus2SP",
    "bonus3SP",
  ],
  accessKey: 0,
}

export const dataSekansGlacier = {
  model: 'sekans',
  edition: 'glacier',
  accessKeyPanel: {
    imgSrc: require("./assets/images/sekansGlacier/sekansGlacierAccessKeyPanel.png"),
    alt: "accessKeyPanel",
  },
  imagesSrc: [
    require("./assets/images/sekansGlacier/mptSekansGlacierFrame.jpg"),
    require("./assets/images/sekansGlacier/kick.png"),
    require("./assets/images/sekansGlacier/snare.png"),
    require("./assets/images/sekansGlacier/closed.png"),
    require("./assets/images/sekansGlacier/open.png"),
    require("./assets/images/sekansGlacier/clap.png"),
    require("./assets/images/sekansGlacier/cowbell.png"),
    require("./assets/images/sekansGlacier/cursorPadUnactive.png"),
    require("./assets/images/sekansGlacier/cursorPadActive.png"),

    require("./assets/images/sekansGlacier/bonusSoundPad1Up.png"),
    require("./assets/images/sekansGlacier/bonusSoundPad1Down.png"),
    require("./assets/images/sekansGlacier/bonusSoundPad2Up.png"),
    require("./assets/images/sekansGlacier/bonusSoundPad2Down.png"),
    require("./assets/images/sekansGlacier/bonusSoundPad3Up.png"),
    require("./assets/images/sekansGlacier/bonusSoundPad3Down.png"),
    require("./assets/images/sekansGlacier/bonusSoundsStopUp.png"),
    require("./assets/images/sekansGlacier/bonusSoundsStopDown.png"),
    require("./assets/images/sekansGlacier/stepLightOff.png"),
    require("./assets/images/sekansGlacier/stepLightOn.png"),

    require("./assets/images/sekansGlacier/bpmDisplay1.png"),
    require("./assets/images/sekansGlacier/bpmDisplay2.png"),
    require("./assets/images/sekansGlacier/bpmDisplay3.png"),
    require("./assets/images/sekansGlacier/bpmDisplay4.png"),
    require("./assets/images/sekansGlacier/bpmDisplay5.png"),
    require("./assets/images/sekansGlacier/bpmMinusUp.png"),
    require("./assets/images/sekansGlacier/bpmMinusDown.png"),
    require("./assets/images/sekansGlacier/bpmPlusUp.png"),
    require("./assets/images/sekansGlacier/bpmPlusDown.png"),
    require("./assets/images/sekansGlacier/playStopUp.png"),
    require("./assets/images/sekansGlacier/playStopDown.png"),
    require("./assets/images/sekansGlacier/arrowUpUp.png"),
    require("./assets/images/sekansGlacier/arrowUpDown.png"),
    require("./assets/images/sekansGlacier/nftLinkUp.png"),
    require("./assets/images/sekansGlacier/nftLinkDown.png"),

    require("./assets/images/sekansGlacier/resetUp.png"),
    require("./assets/images/sekansGlacier/resetDown.png"),
    require("./assets/images/sekansGlacier/clearPadsUp.png"),
    require("./assets/images/sekansGlacier/clearPadsDown.png"),
    require("./assets/images/sekansGlacier/clearLineUp.png"),
    require("./assets/images/sekansGlacier/clearLineDown.png"),
    require("./assets/images/sekansGlacier/mutePadsUp.png"),
    require("./assets/images/sekansGlacier/mutePadsDown.png"),
    require("./assets/images/sekansGlacier/activateCursorUp.png"),
    require("./assets/images/sekansGlacier/activateCursorDown.png"),
    require("./assets/images/sekansGlacier/arrowLeftUp.png"),
    require("./assets/images/sekansGlacier/arrowLeftDown.png"),
    require("./assets/images/sekansGlacier/arrowDownUp.png"),
    require("./assets/images/sekansGlacier/arrowDownDown.png"),
    require("./assets/images/sekansGlacier/arrowRightUp.png"),
    require("./assets/images/sekansGlacier/arrowRightDown.png"),
  ],
  nftPath: "https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/57703132890668813036986655783405950636450175475927794675628972160019930808321",
  contractAdress: "0x495f947276749ce646f68ac8c248420045cb7b5e",
  tokenId: "57703132890668813036986655783405950636450175475927794675628972160019930808321",
  audios: [
    "kickSG",
    "snareSG",
    "hihatSG",
    "openHihatSG",
    "clapSG",
    "cowbellSG",
    "bonus1SG",
    "bonus2SG",
    "bonus3SG",
  ],
  accessKey: 0,
}

export const dataSekansAcid = {
  model: 'sekans',
  edition: 'acid',
  accessKeyPanel: {
    imgSrc: require("./assets/images/sekansAcid/sekansAcidAccessKeyPanel.png"),
    alt: "accessKeyPanel",
  },
  imagesSrc: [
    require("./assets/images/sekansAcid/mptSekansAcidFrame.jpg"),
    require("./assets/images/sekansAcid/kick.png"),
    require("./assets/images/sekansAcid/snare.png"),
    require("./assets/images/sekansAcid/closed.png"),
    require("./assets/images/sekansAcid/open.png"),
    require("./assets/images/sekansAcid/clap.png"),
    require("./assets/images/sekansAcid/cowbell.png"),
    require("./assets/images/sekansAcid/cursorPadUnactive.png"),
    require("./assets/images/sekansAcid/cursorPadActive.png"),

    require("./assets/images/sekansAcid/bonusSoundPad1Up.png"),
    require("./assets/images/sekansAcid/bonusSoundPad1Down.png"),
    require("./assets/images/sekansAcid/bonusSoundPad2Up.png"),
    require("./assets/images/sekansAcid/bonusSoundPad2Down.png"),
    require("./assets/images/sekansAcid/bonusSoundPad3Up.png"),
    require("./assets/images/sekansAcid/bonusSoundPad3Down.png"),
    require("./assets/images/sekansAcid/bonusSoundsStopUp.png"),
    require("./assets/images/sekansAcid/bonusSoundsStopDown.png"),
    require("./assets/images/sekansAcid/stepLightOff.png"),
    require("./assets/images/sekansAcid/stepLightOn.png"),

    require("./assets/images/sekansAcid/bpmDisplay1.png"),
    require("./assets/images/sekansAcid/bpmDisplay2.png"),
    require("./assets/images/sekansAcid/bpmDisplay3.png"),
    require("./assets/images/sekansAcid/bpmDisplay4.png"),
    require("./assets/images/sekansAcid/bpmDisplay5.png"),
    require("./assets/images/sekansAcid/bpmMinusUp.png"),
    require("./assets/images/sekansAcid/bpmMinusDown.png"),
    require("./assets/images/sekansAcid/bpmPlusUp.png"),
    require("./assets/images/sekansAcid/bpmPlusDown.png"),
    require("./assets/images/sekansAcid/playStopUp.png"),
    require("./assets/images/sekansAcid/playStopDown.png"),
    require("./assets/images/sekansAcid/arrowUpUp.png"),
    require("./assets/images/sekansAcid/arrowUpDown.png"),
    require("./assets/images/sekansAcid/nftLinkUp.png"),
    require("./assets/images/sekansAcid/nftLinkDown.png"),

    require("./assets/images/sekansAcid/resetUp.png"),
    require("./assets/images/sekansAcid/resetDown.png"),
    require("./assets/images/sekansAcid/clearPadsUp.png"),
    require("./assets/images/sekansAcid/clearPadsDown.png"),
    require("./assets/images/sekansAcid/clearLineUp.png"),
    require("./assets/images/sekansAcid/clearLineDown.png"),
    require("./assets/images/sekansAcid/mutePadsUp.png"),
    require("./assets/images/sekansAcid/mutePadsDown.png"),
    require("./assets/images/sekansAcid/activateCursorUp.png"),
    require("./assets/images/sekansAcid/activateCursorDown.png"),
    require("./assets/images/sekansAcid/arrowLeftUp.png"),
    require("./assets/images/sekansAcid/arrowLeftDown.png"),
    require("./assets/images/sekansAcid/arrowDownUp.png"),
    require("./assets/images/sekansAcid/arrowDownDown.png"),
    require("./assets/images/sekansAcid/arrowRightUp.png"),
    require("./assets/images/sekansAcid/arrowRightDown.png"),
  ],
  nftPath: "https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/57703132890668813036986655783405950636450175475927794675628972162218954063873",
  contractAdress: "0x495f947276749ce646f68ac8c248420045cb7b5e",
  tokenId: "57703132890668813036986655783405950636450175475927794675628972162218954063873",
  audios: [
    "kickSA",
    "snareSA",
    "hihatSA",
    "openHihatSA",
    "clapSA",
    "cowbellSA",
    "bonus1SA",
    "bonus2SA",
    "bonus3SA",
  ],
  accessKey: 0,
}

export const dataSekansVolcano = {
  model: 'sekans',
  edition: 'volcano',
  accessKeyPanel: {
    imgSrc: require("./assets/images/sekansVolcano/sekansVolcanoAccessKeyPanel.png"),
    alt: "accessKeyPanel",
  },
  imagesSrc: [
    require("./assets/images/sekansVolcano/mptSekansVolcanoFrame.jpg"),
    require("./assets/images/sekansVolcano/kick.png"),
    require("./assets/images/sekansVolcano/snare.png"),
    require("./assets/images/sekansVolcano/closed.png"),
    require("./assets/images/sekansVolcano/open.png"),
    require("./assets/images/sekansVolcano/clap.png"),
    require("./assets/images/sekansVolcano/cowbell.png"),
    require("./assets/images/sekansVolcano/cursorPadUnactive.png"),
    require("./assets/images/sekansVolcano/cursorPadActive.png"),

    require("./assets/images/sekansVolcano/bonusSoundPad1Up.png"),
    require("./assets/images/sekansVolcano/bonusSoundPad1Down.png"),
    require("./assets/images/sekansVolcano/bonusSoundPad2Up.png"),
    require("./assets/images/sekansVolcano/bonusSoundPad2Down.png"),
    require("./assets/images/sekansVolcano/bonusSoundPad3Up.png"),
    require("./assets/images/sekansVolcano/bonusSoundPad3Down.png"),
    require("./assets/images/sekansVolcano/bonusSoundsStopUp.png"),
    require("./assets/images/sekansVolcano/bonusSoundsStopDown.png"),
    require("./assets/images/sekansVolcano/stepLightOff.png"),
    require("./assets/images/sekansVolcano/stepLightOn.png"),

    require("./assets/images/sekansVolcano/bpmDisplay1.png"),
    require("./assets/images/sekansVolcano/bpmDisplay2.png"),
    require("./assets/images/sekansVolcano/bpmDisplay3.png"),
    require("./assets/images/sekansVolcano/bpmDisplay4.png"),
    require("./assets/images/sekansVolcano/bpmDisplay5.png"),
    require("./assets/images/sekansVolcano/bpmMinusUp.png"),
    require("./assets/images/sekansVolcano/bpmMinusDown.png"),
    require("./assets/images/sekansVolcano/bpmPlusUp.png"),
    require("./assets/images/sekansVolcano/bpmPlusDown.png"),
    require("./assets/images/sekansVolcano/playStopUp.png"),
    require("./assets/images/sekansVolcano/playStopDown.png"),
    require("./assets/images/sekansVolcano/arrowUpUp.png"),
    require("./assets/images/sekansVolcano/arrowUpDown.png"),
    require("./assets/images/sekansVolcano/nftLinkUp.png"),
    require("./assets/images/sekansVolcano/nftLinkDown.png"),

    require("./assets/images/sekansVolcano/resetUp.png"),
    require("./assets/images/sekansVolcano/resetDown.png"),
    require("./assets/images/sekansVolcano/clearPadsUp.png"),
    require("./assets/images/sekansVolcano/clearPadsDown.png"),
    require("./assets/images/sekansVolcano/clearLineUp.png"),
    require("./assets/images/sekansVolcano/clearLineDown.png"),
    require("./assets/images/sekansVolcano/mutePadsUp.png"),
    require("./assets/images/sekansVolcano/mutePadsDown.png"),
    require("./assets/images/sekansVolcano/activateCursorUp.png"),
    require("./assets/images/sekansVolcano/activateCursorDown.png"),
    require("./assets/images/sekansVolcano/arrowLeftUp.png"),
    require("./assets/images/sekansVolcano/arrowLeftDown.png"),
    require("./assets/images/sekansVolcano/arrowDownUp.png"),
    require("./assets/images/sekansVolcano/arrowDownDown.png"),
    require("./assets/images/sekansVolcano/arrowRightUp.png"),
    require("./assets/images/sekansVolcano/arrowRightDown.png"),
  ],
  nftPath: "https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/57703132890668813036986655783405950636450175475927794675628972163318465691649",
  contractAdress: "0x495f947276749ce646f68ac8c248420045cb7b5e",
  tokenId: "57703132890668813036986655783405950636450175475927794675628972163318465691649",
  audios: [
    "kickSV",
    "snareSV",
    "hihatSV",
    "openHihatSV",
    "clapSV",
    "cowbellSV",
    "bonus1SV",
    "bonus2SV",
    "bonus3SV",
  ],
  accessKey: 0,
}

export const dataSekansRoyale = {
  model: 'sekans',
  edition: 'royale',
  accessKeyPanel: {
    imgSrc: require("./assets/images/sekansRoyale/sekansRoyaleAccessKeyPanel.png"),
    alt: "accessKeyPanel",
  },
  imagesSrc: [
    require("./assets/images/sekansRoyale/mptSekansRoyaleFrame.jpg"),
    require("./assets/images/sekansRoyale/kick.png"),
    require("./assets/images/sekansRoyale/snare.png"),
    require("./assets/images/sekansRoyale/closed.png"),
    require("./assets/images/sekansRoyale/open.png"),
    require("./assets/images/sekansRoyale/clap.png"),
    require("./assets/images/sekansRoyale/cowbell.png"),
    require("./assets/images/sekansRoyale/cursorPadUnactive.png"),
    require("./assets/images/sekansRoyale/cursorPadActive.png"),

    require("./assets/images/sekansRoyale/bonusSoundPad1Up.png"),
    require("./assets/images/sekansRoyale/bonusSoundPad1Down.png"),
    require("./assets/images/sekansRoyale/bonusSoundPad2Up.png"),
    require("./assets/images/sekansRoyale/bonusSoundPad2Down.png"),
    require("./assets/images/sekansRoyale/bonusSoundPad3Up.png"),
    require("./assets/images/sekansRoyale/bonusSoundPad3Down.png"),
    require("./assets/images/sekansRoyale/bonusSoundsStopUp.png"),
    require("./assets/images/sekansRoyale/bonusSoundsStopDown.png"),
    require("./assets/images/sekansRoyale/stepLightOff.png"),
    require("./assets/images/sekansRoyale/stepLightOn.png"),

    require("./assets/images/sekansRoyale/bpmDisplay1.png"),
    require("./assets/images/sekansRoyale/bpmDisplay2.png"),
    require("./assets/images/sekansRoyale/bpmDisplay3.png"),
    require("./assets/images/sekansRoyale/bpmDisplay4.png"),
    require("./assets/images/sekansRoyale/bpmDisplay5.png"),
    require("./assets/images/sekansRoyale/bpmMinusUp.png"),
    require("./assets/images/sekansRoyale/bpmMinusDown.png"),
    require("./assets/images/sekansRoyale/bpmPlusUp.png"),
    require("./assets/images/sekansRoyale/bpmPlusDown.png"),
    require("./assets/images/sekansRoyale/playStopUp.png"),
    require("./assets/images/sekansRoyale/playStopDown.png"),
    require("./assets/images/sekansRoyale/arrowUpUp.png"),
    require("./assets/images/sekansRoyale/arrowUpDown.png"),
    require("./assets/images/sekansRoyale/nftLinkUp.png"),
    require("./assets/images/sekansRoyale/nftLinkDown.png"),

    require("./assets/images/sekansRoyale/resetUp.png"),
    require("./assets/images/sekansRoyale/resetDown.png"),
    require("./assets/images/sekansRoyale/clearPadsUp.png"),
    require("./assets/images/sekansRoyale/clearPadsDown.png"),
    require("./assets/images/sekansRoyale/clearLineUp.png"),
    require("./assets/images/sekansRoyale/clearLineDown.png"),
    require("./assets/images/sekansRoyale/mutePadsUp.png"),
    require("./assets/images/sekansRoyale/mutePadsDown.png"),
    require("./assets/images/sekansRoyale/activateCursorUp.png"),
    require("./assets/images/sekansRoyale/activateCursorDown.png"),
    require("./assets/images/sekansRoyale/arrowLeftUp.png"),
    require("./assets/images/sekansRoyale/arrowLeftDown.png"),
    require("./assets/images/sekansRoyale/arrowDownUp.png"),
    require("./assets/images/sekansRoyale/arrowDownDown.png"),
    require("./assets/images/sekansRoyale/arrowRightUp.png"),
    require("./assets/images/sekansRoyale/arrowRightDown.png"),
  ],
  nftPath: "https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/57703132890668813036986655783405950636450175475927794675628972161119442436097",
  contractAdress: "0x495f947276749ce646f68ac8c248420045cb7b5e",
  tokenId: "57703132890668813036986655783405950636450175475927794675628972161119442436097",
  audios: [
    "kickSR",
    "snareSR",
    "hihatSR",
    "openHihatSR",
    "clapSR",
    "cowbellSR",
    "bonus1SR",
    "bonus2SR",
    "bonus3SR",
  ],
  accessKey: 0,
}

export const dataPiano = {
  model: 'piano',
  edition: 'prototype',
  accessKeyPanel: {
    imgSrc: require("./assets/images/piano/pianoAccessKeyPanel.png"),
    alt: "accessKeyPanel",
  },
  imagesSrc: [
    require("./assets/images/piano/mptPianoFrame.jpg"),
    require("./assets/images/piano/stepLightOff.png"),
    require("./assets/images/piano/stepLightOn.png"),
    require("./assets/images/piano/bpmDisplay1.png"),
    require("./assets/images/piano/bpmDisplay2.png"),
    require("./assets/images/piano/bpmDisplay3.png"),
    require("./assets/images/piano/bpmDisplay4.png"),
    require("./assets/images/piano/bpmDisplay5.png"),
    require("./assets/images/piano/bpmMinusUp.png"),
    require("./assets/images/piano/bpmMinusDown.png"),
    require("./assets/images/piano/bpmPlusUp.png"),
    require("./assets/images/piano/bpmPlusDown.png"),
    require("./assets/images/piano/monoUp.png"),
    require("./assets/images/piano/monoDown.png"),
    require("./assets/images/piano/polyUp.png"),
    require("./assets/images/piano/polyDown.png"),
  ],
  nftPath: "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/57703132890668813036986655783405950636450175475927794675628972158920419180545",
  contractAdress: "0x495f947276749ce646f68ac8c248420045cb7b5e",
  tokenId: "57703132890668813036986655783405950636450175475927794675628972158920419180545",
  audios: [
    "pianoNote1",
    "pianoNote2",
    "pianoNote3",
    "pianoNote4",
    "pianoNote5",
    "pianoNote6",
    "pianoNote7",
    "pianoNote8",
    "pianoNote9",
    "pianoNote10",
    "pianoNote11",
    "pianoNote12",
  ],
  accessKey: 0,
}

export const dataArpeggioPrototype = {
  model: 'arpeggio',
  edition: 'prototype',
  accessKeyPanel: {
    imgSrc: require("./assets/images/arpeggioPrototype/arpeggioPrototypeAccessKeyPanel.png"),
    alt: "accessKeyPanel",
  },
  imagesSrc: [
    require("./assets/images/arpeggioPrototype/activateDown.png"), // 0
    require("./assets/images/arpeggioPrototype/activateUp.png"), // 1
    require("./assets/images/arpeggioPrototype/arrowDownDown.png"), // 2
    require("./assets/images/arpeggioPrototype/arrowDownUp.png"), // 3
    require("./assets/images/arpeggioPrototype/arrowLeftDown.png"), // 4
    require("./assets/images/arpeggioPrototype/arrowLeftUp.png"), // 5 
    require("./assets/images/arpeggioPrototype/arrowRightDown.png"), // 6
    require("./assets/images/arpeggioPrototype/arrowRightUp.png"), // 7
    require("./assets/images/arpeggioPrototype/arrowUpDown.png"), // 8
    require("./assets/images/arpeggioPrototype/arrowUpUp.png"), // 9
    require("./assets/images/arpeggioPrototype/bpmDisplay1.png"), // 10
    require("./assets/images/arpeggioPrototype/bpmDisplay2.png"), // 11
    require("./assets/images/arpeggioPrototype/bpmDisplay3.png"), // 12
    require("./assets/images/arpeggioPrototype/bpmDisplay4.png"), // 13
    require("./assets/images/arpeggioPrototype/bpmDisplay5.png"), // 14
    require("./assets/images/arpeggioPrototype/monoDown.png"), // 15
    require("./assets/images/arpeggioPrototype/monoUp.png"), // 16
    require("./assets/images/arpeggioPrototype/nftLinkDown.png"), // 17
    require("./assets/images/arpeggioPrototype/nftLinkUp.png"), // 18 
    require("./assets/images/arpeggioPrototype/playDown.png"), // 19
    require("./assets/images/arpeggioPrototype/playUp.png"), // 20
    require("./assets/images/arpeggioPrototype/polyDown.png"), // 21
    require("./assets/images/arpeggioPrototype/polyUp.png"), // 22
    require("./assets/images/arpeggioPrototype/stepLightOff.png"), // 23
    require("./assets/images/arpeggioPrototype/stepLightOn.png"), // 24
    require("./assets/images/arpeggioPrototype/wipeDown.png"), // 25
    require("./assets/images/arpeggioPrototype/wipeUp.png"), // 26
    require("./assets/images/arpeggioPrototype/writeDown.png"), // 27
    require("./assets/images/arpeggioPrototype/writeUp.png"), // 28
    require("./assets/images/arpeggioPrototype/mptArpeggioPrototypeFrame.png"), // 29
  ],
  nftPath: "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/57703132890668813036986655783405950636450175475927794675628972147925302902785",
  contractAdress: "0x495f947276749Ce646f68AC8c248420045cb7b5e",
  tokenId: "57703132890668813036986655783405950636450175475927794675628972147925302902785",
  audios: [
    "pianoNote1",
    "pianoNote2",
    "pianoNote3",
    "kickXG",
    "snareXG",
    "hihatXG",
    "pianoNote4",
    "pianoNote5",
    "pianoNote6",
  ],
  accessKey: 0,
}